import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  entry: {
    justifyContent: 'flex-start',
    columnGap: tokens.spacingHorizontalXS,
    width: '100%',
    paddingInline: tokens.spacingHorizontalM,
    paddingBlock: tokens.spacingVerticalS,
    border: 'none',
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke3}`,
  },
  name: {
    flexGrow: 1,
    minWidth: 0,
    textAlign: 'left',
    fontSize: tokens.fontSizeBase200,
  },
  annotatedIcon: { flexShrink: 0, color: tokens.colorStatusSuccessForeground1 },
  files: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    border: 'none',
    borderRadius: 0,
    padding: 0,
    rowGap: 0,
    backgroundColor: tokens.colorNeutralBackground2,
  },
  file: {
    justifyContent: 'flex-start',
    width: '100%',
    paddingBlock: tokens.spacingVerticalXS,
    paddingInlineStart: tokens.spacingHorizontalXXL,
    paddingInlineEnd: tokens.spacingHorizontalM,
    border: 'none',
  },
  selected: {
    backgroundColor: tokens.colorNeutralBackground1Selected,
    ':hover': { backgroundColor: tokens.colorNeutralBackground1Selected },
  },
});
